import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Providers/AuthProvider';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-dark text-light">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando sesión...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role)) {
      return (
        <div className="container mt-5 text-center text-light">
          <h2>Acceso Denegado</h2>
          <p>No tienes los permisos necesarios para acceder a esta sección.</p>
          <a href="/admin/dashboard" className="btn btn-primary mt-3">Volver al Dashboard</a>
        </div>
      );
    }
  }

  return children;
};
